import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Start playing video automatically when component mounts
  }, []);

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="video-container">
            <div className="video-placeholder">
              <div className="fake-video">
                <video 
                  ref={videoRef}
                  className="hero-video"
                  width="1" 
                  height="1"
                  playsInline
                  muted
                  loop
                  autoPlay
                  preload="auto"
                  controls={true}
                >
                  <source src="/videos/contractwell.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          
          <div className="hero-text">
            <h2>Legal protection shouldn't be a luxury.</h2>
            <p className="hero-text-bg">Lawyer-grade contract templates without the lawyer-grade price. Clear, affordable, and ready to use in minutes, so you never have to choose between cost and protection.</p>
            <Link to="/library" className="btn get-started-btn">Shop Contracts</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
